import ControlsBar, { ControlsBarSpace } from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import PlainTooltip from 'app/common/ui-next/plain-tooltip'
import PlainActionsButtons from 'app/common/ui-next/plain-actions-button'
import { useSelectionAsArray } from 'app/common/ui-components/table'

import { AddProductionTypeModal } from './AddProductionTypeModal'
import { DeleteProductionTypeModal } from './DeleteProductionTypeModal'


type Props = {
  disabled?: boolean
}

export const ProductionTypesToolbar = ({ disabled }: Props) => {
  const selection = useSelectionAsArray()
  const selectedNumber = selection.length

  return (
    <ControlsBar>
      <AddProductionTypeModal>
        {toggle => (
          <PlainButton disabled={disabled} onClick={toggle}>
            {'Добавить тип продукции'}
          </PlainButton>
        )}
      </AddProductionTypeModal>

      <ControlsBarSpace />

      <DeleteProductionTypeModal saleTypeId={selection}>
        {toggle => (
          <PlainTooltip
            text={!selectedNumber ? 'Необходимо выбрать хотя бы один тип продукции' : null}
            enableOverflow
          >
            <PlainActionsButtons
              collapsed
              value="Изменить"
              number={selectedNumber}
              valueMask="Изменить (%n%)"
              disabled={!selectedNumber}
            >
              <PlainButton
                id="delete"
                onClick={toggle}
                disabled={!selectedNumber}
              >
                {selectedNumber > 0
                  ? `Удалить (${selectedNumber})`
                  : 'Удалить'}
              </PlainButton>
            </PlainActionsButtons>
          </PlainTooltip>
        )}
      </DeleteProductionTypeModal>
    </ControlsBar>
  )
}
